import React from 'react';

export const SidebarHelpIcon = ({ className = '' }: { className?: string }) => (
  <svg
    className={className}
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.3325 8.25C8.54801 7.63736 8.97339 7.12077 9.53333 6.7917C10.0932 6.46265 10.7515 6.34236 11.3916 6.45215C12.0317 6.56195 12.6122 6.89473 13.0305 7.39157C13.4487 7.8884 13.6777 8.51723 13.6767 9.16667C13.6767 11 10.9267 11.9167 10.9267 11.9167M11 15.5833H11.0092M20.1667 11C20.1667 16.0626 16.0626 20.1667 11 20.1667C5.93739 20.1667 1.83333 16.0626 1.83333 11C1.83333 5.93739 5.93739 1.83333 11 1.83333C16.0626 1.83333 20.1667 5.93739 20.1667 11Z"
      stroke="white"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
